module.exports = __webpack_public_path__ + "3f9b798decb60e4635d8a1ae03043cda.pdf";